import enIcon from '/public/images/flag/en.png';
import ruIcon from '/public/images/flag/ru.png';

export const LANGUAGES = [
	{
		code: 'ru',
		icon: ruIcon,
		name: 'Russian',
	},
	{
		code: 'en',
		icon: enIcon,
		name: 'English',
	},
] as const;

export type TLanguage = (typeof LANGUAGES)[number];

export type TLocale = (typeof LANGUAGES)[number]['code'];

export const LOCALES: TLocale[] = LANGUAGES.map((lang) => lang.code);
